import { defineRouting } from "next-intl/routing";
import { defaultLocale, locales } from "./routing/locales";
import { contentPathnames } from "./routing/pathnames/content";
import { mainPathnames } from "./routing/pathnames/main";
import { secondaryPathnames } from "./routing/pathnames/secondary";

const pathnames = {
  ...mainPathnames,
  ...secondaryPathnames,
  ...contentPathnames,
} as const;

export const routing = defineRouting({
  locales: [...locales],
  defaultLocale,
  pathnames,
  // hreflang comes from each page's metadata; the middleware's Link header
  // would publish a second, conflicting set.
  alternateLinks: false,
});

export { defaultLocale, locales } from "./routing/locales";
